module.exports = __webpack_public_path__ + "static/media/map.db27b472.svg";